var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScalelupSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 553.59 553.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5dd39e;\n      }\n\n      .cls-2 {\n        fill: #ead015;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.13,442.71l-166.85,55.6,55.6-166.84c1.21-3.62-.75-7.53-4.37-8.74-28.2-9.42-58.8-2.2-79.83,18.82-21.03,21.02-28.26,51.6-18.87,79.82l29.99,90.04c.08.23.23.42.33.64.19.43.37.87.65,1.25.24.33.55.57.84.85.22.22.41.47.66.65.45.33.97.56,1.49.77.14.06.26.16.4.21h.03s.01.01.02.02l90,29.97c8.17,2.72,16.55,4.05,24.83,4.05,20.3,0,40.05-7.97,54.98-22.91,21.02-21.03,28.24-51.62,18.83-79.83-1.21-3.62-5.11-5.58-8.73-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M538.29,19.67c-.69-2.06-2.31-3.68-4.37-4.37-106.56-35.49-222.09-8.21-301.5,71.21l-58.75,58.75c-36.03-10.37-74.42-.56-101.12,26.14L2.02,241.92c-1.69,1.69-2.39,4.14-1.84,6.47.55,2.33,2.27,4.21,4.54,4.96l111.85,37.26c.21.09.43.18.66.26l109.11,36.37,36.37,109.11c.07.21.16.43.25.63l37.27,111.87c.76,2.27,2.64,3.99,4.97,4.54.53.13,1.06.18,1.59.18,1.81,0,3.57-.71,4.88-2.02l70.52-70.52c26.7-26.7,36.52-65.1,26.14-101.13l58.75-58.75c79.42-79.42,106.7-194.95,71.21-301.5ZM353.65,141.24c32.36,0,58.69,26.33,58.69,58.69s-26.33,58.69-58.69,58.69-58.69-26.33-58.69-58.69,26.33-58.69,58.69-58.69Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalelupSymbol);
export default __webpack_public_path__ + "static/media/scalelup-symbol.7db19a3ab4f8b1c304e235530362c9ff.svg";
export { ForwardRef as ReactComponent };